import { useNavigate } from "react-router-dom";
import { Users, Building2, ArrowRight, List } from "lucide-react";
import { LOGO_URL } from "@/lib/brand";
import { TricolorBar } from "@/components/FormHeader";

const CHOICES = [
  {
    key: "buyer", icon: Users, title: "Scheda Contatto Buyer",
    desc: "Raccolta lead in fiera: anagrafica buyer, interessi, campioni e valutazione.",
    form: "/buyer", list: "/storico", listLabel: "Elenco Contatti Raccolti",
  },
  {
    key: "cliente", icon: Building2, title: "Scheda Anagrafica Cliente",
    desc: "Nuovo cliente o aggiornamento: dati fiscali, referenti, sede e indirizzi.",
    form: "/anagrafica", list: "/anagrafica/elenco", listLabel: "Elenco Anagrafiche",
  },
];

const ChoiceCard = ({ c, i }) => {
  const navigate = useNavigate();
  const Icon = c.icon;
  return (
    <div
      className="group bg-white rounded-3xl border border-gray-200 shadow-sm overflow-hidden flex flex-col transition-[box-shadow,transform] duration-300 hover:shadow-xl hover:-translate-y-1 animate-in fade-in slide-in-from-bottom-4"
      style={{ animationDelay: `${i * 120}ms`, animationFillMode: "both" }}
    >
      <button type="button" data-testid={`home-open-${c.key}`} onClick={() => navigate(c.form)} className="text-left p-7 md:p-8 flex-1 flex flex-col gap-5">
        <div className="w-14 h-14 rounded-2xl bg-buscema-green flex items-center justify-center transition-colors duration-300 group-hover:bg-buscema-gold">
          <Icon className="w-7 h-7 text-white" />
        </div>
        <div className="space-y-2">
          <h2 className="font-heading text-2xl font-bold tracking-tight text-buscema-green">{c.title}</h2>
          <p className="text-sm md:text-base text-gray-500 leading-relaxed">{c.desc}</p>
        </div>
        <span className="mt-auto inline-flex items-center gap-2 font-semibold text-buscema-gold">
          Compila scheda <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
        </span>
      </button>
      <button
        type="button"
        data-testid={`home-list-${c.key}`}
        onClick={() => navigate(c.list)}
        className="border-t border-gray-100 px-7 md:px-8 py-4 flex items-center gap-2 text-sm font-semibold text-gray-600 hover:bg-buscema-green hover:text-white transition-colors"
      >
        <List className="w-4 h-4" /> {c.listLabel}
      </button>
    </div>
  );
};

export default function Home() {
  return (
    <div className="min-h-screen bg-gray-50 font-body" data-testid="home-page">
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-5xl mx-auto px-4 py-4 flex justify-center">
          <img src={LOGO_URL} alt="Buscema Gastronomia" className="h-16 sm:h-20 w-auto" data-testid="brand-logo" />
        </div>
        <TricolorBar />
      </header>
      <main className="max-w-5xl mx-auto px-4 py-10 md:py-16 space-y-8">
        <div className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-buscema-gold">Raccolta dati</p>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-buscema-green">Quale scheda vuoi compilare?</h1>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {CHOICES.map((c, i) => <ChoiceCard key={c.key} c={c} i={i} />)}
        </div>
      </main>
    </div>
  );
}
